import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import taskDetail from 'features/views/taskDetail';
import { TARIF_DEFAULT } from 'features/views/taskOverview/constants';
import { equalOrThreeDashes, getCodelistPropById } from 'utils';
import { equalOrValue } from 'utils/equalOrThreeDashes';
import { nonEmptyNumber } from 'utils/formats';

export const AdditionalInformationPSTable = ({ productTypes }) => {
	const metadataCommon = useSelector(taskDetail.selectors.getMetaDataCommon);
	const productShortName = getCodelistPropById(metadataCommon.productId, productTypes, 'shortDescription');

	return (
		<TableContainer>
			<Table sx={{ mt: 2 }} size="small">
				<TableHead>
					<TableRow>
						<TableCell>
							<div>{getLabelMessage('detail:additionalInformationsSalery')}</div>
							<div>{getLabelMessage('detail:additionalInformationsValorization')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('detail:additionalInformationsInsurace')}</div>
							<div>{getLabelMessage('detail:additionalInformationsInsuraceTax')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('detail:additionalInformationsPaidInsurance')}</div>
							<div>{getLabelMessage('detail:additionalInformationsOverwriteInsurance')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('detail:additionalInformationsLoyaltyPremium')}</div>
							<div>{getLabelMessage('detail:additionalInformationsLoyaltyBonus')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('detail:additionalInformationsPremium')}</div>
							<div>{getLabelMessage('detail:additionalInformationsTotal')}</div>
						</TableCell>
						<TableCell>
							<div>{getLabelMessage('detail:additionalInformationsRate')}</div>
							<div>{getLabelMessage('detail:additionalInformationsTarif')}</div>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					<TableRow>
						<TableCell>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.totalCompensationAmount))}</div>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.valorizationAmount))}</div>
						</TableCell>
						<TableCell>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.lifeInsuranceAmount))}</div>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.tax))}</div>
						</TableCell>
						<TableCell>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.prescriptionPremiumAmount))}</div>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.prescriptionPremiumOneAmount))}</div>
						</TableCell>
						<TableCell>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.loyaltyPremium))}</div>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.loyaltyBonus))}</div>
						</TableCell>
						<TableCell>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.rewardAmount))}</div>
							<div>{equalOrThreeDashes(nonEmptyNumber(metadataCommon.totalCompensationAmount))}</div>
						</TableCell>
						<TableCell>
							<div>{equalOrThreeDashes(metadataCommon.rate)}</div>
							<div>{equalOrValue(TARIF_DEFAULT, productShortName)}</div>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
};

AdditionalInformationPSTable.propTypes = {
	productTypes: PropTypes.array,
};

export default AdditionalInformationPSTable;
